import { Fragment, useState, ReactElement } from 'react'
import IdleTimer from 'react-idle-timer'
import { useDispatch, useSelector } from 'react-redux'
import IdleDialog from './IdleDialog'
import { useUser } from '../../Permissions'
import { logout } from '../../App/LegacyLogin/login.actions'
import { RootState } from '../../App/app.reducer'
import { datadogRum } from '@datadog/browser-rum'

const MS_PER_S = 1000
const S_PER_MIN = 60
const MS_PER_MIN = S_PER_MIN * MS_PER_S

const ConeIdleTimer = (): ReactElement => {
  const dispatch = useDispatch()
  const user = useUser()
  const [idle, setIdle] = useState(false)
  const [idleTimer, setIdleTimer] = useState<$TSFIXME>(null)
  const forgerockIdToken = useSelector((state: RootState) => state.app.forgerockIdToken)
  const frLoginUrl = useSelector((state: RootState) => state.app.frLoginUrl)
  const frOpUrl = useSelector((state: RootState) => state.app.frOpUrl)
  const frRealm = useSelector((state: RootState) => state.app.frRealm)
  const wasAuthFR = useSelector((state: RootState) => state.app.wasAuthFR)

  const handleIdle = () => setIdle(true)

  const handleIdleTimeout = (): void => {
    setIdle(true)
    datadogRum.addAction('Logout called', { caller: 'Common/ConeIdleTimer' })
    dispatch(logout(forgerockIdToken, frLoginUrl, frOpUrl, frRealm, wasAuthFR))
  }
  const handleStayLoggedIn = (): void => {
    if (idleTimer) {
      idleTimer.reset()
    }
    setIdle(false)
  }
  return (
    <Fragment>
      <IdleTimer ref={(ref: IdleTimer) => setIdleTimer(ref)} timeout={Number(user?.sessionTimeout) * MS_PER_MIN} onIdle={handleIdle} />
      <IdleDialog open={idle} onTimeout={handleIdleTimeout} onConfirm={handleStayLoggedIn} />
    </Fragment>
  )
}

export default ConeIdleTimer
